import { render, staticRenderFns } from "./IconMediaAdd.vue?vue&type=template&id=538e5ee3&"
import script from "./IconMediaAdd.vue?vue&type=script&lang=js&"
export * from "./IconMediaAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('538e5ee3')) {
      api.createRecord('538e5ee3', component.options)
    } else {
      api.reload('538e5ee3', component.options)
    }
    module.hot.accept("./IconMediaAdd.vue?vue&type=template&id=538e5ee3&", function () {
      api.rerender('538e5ee3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconMediaAdd.vue"
export default component.exports